import { useApprovalInboxStore } from '../stores/approvalInboxStore'
import { usePlatformActionStore } from '../stores/platformActionStore'

import { registerSessionReset } from '@/features/auth'

/** Clear workspace-scoped action requests on logout so rows never cross tenant boundaries. */
export function registerPlatformActionSessionReset(): () => void {
  const store = usePlatformActionStore()
  const inbox = useApprovalInboxStore()
  return registerSessionReset(() => {
    store.reset()
    inbox.reset()
  })
}
